// import { createSlice } from '@reduxjs/toolkit'

// const authSlice = createSlice({
//     name: 'auth',
//     initialState: { token: null },
//     reducers: {
//         setToken: (state, action) => { state.token = action.payload },
//         clearToken: (state) => { state.token = null }
//     }
// })

// export const { setToken, clearToken } = authSlice.actions
// export default authSlice.reducer


import { createSlice } from '@reduxjs/toolkit'

const authSlice = createSlice({
    name: 'auth',
    initialState: { isAuthenticated: false },
    reducers: {
        userSignedIn: (state) => { state.isAuthenticated = true },
        userSignedOut: (state) => { state.isAuthenticated = false }
    }
})

export const { userSignedIn, userSignedOut } = authSlice.actions
export default authSlice.reducer